module.exports = __webpack_public_path__ + "static/media/detalle_n_pedido.3d72f460.png";